import { render, staticRenderFns } from "./PassoDadosPessoais.vue?vue&type=template&id=37dc2a67"
import script from "./PassoDadosPessoais.vue?vue&type=script&lang=js"
export * from "./PassoDadosPessoais.vue?vue&type=script&lang=js"
import style0 from "./PassoDadosPessoais.vue?vue&type=style&index=0&id=37dc2a67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRadio,VRadioGroup,VTextField})
